import { render, staticRenderFns } from "./orgProductDialog.vue?vue&type=template&id=e819961a&scoped=true"
import script from "./orgProductDialog.vue?vue&type=script&lang=js"
export * from "./orgProductDialog.vue?vue&type=script&lang=js"
import style0 from "./orgProductDialog.vue?vue&type=style&index=0&id=e819961a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e819961a",
  null
  
)

export default component.exports